import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box, 
  Button,
  ButtonGroup,
  CircularProgress,
  Fade,
  Grid,
  Grow,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles"

import { Link } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux";
import firebase, { auth } from "../utils/firebaseConfig"

import { deleteItem } from "../actions";
import { SnackbarProvider, useSnackbar } from 'notistack';


import tableIcons from "../components/tableFormatting/tableIcons";

import NanoCompVisualiser from "../components/NanoCompVisualiser"

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import FolderIcon from '@mui/icons-material/Folder';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';

import CreateNanoCompModal from "../components/CreateNanoCompModal";
import { ConstructionOutlined } from "@mui/icons-material";
import { autoCol } from "@syncfusion/ej2-react-grids";

 
const NanoComp = () => {
  const [isLoading, setIsLoading] = useState(true);

  const localStore = useSelector(state => state.nanoCompDataReducer);
  const [data, setData] = useState([]);
  const [selectedDataSet, setSelectedDataSet] = useState(1);
  const [totalLength, setTotalLength] = useState();
  const auth = useSelector(state => state.firebase);


  
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);

    }, 1000)
  },[])


  useEffect(() => {
    async function getdata() {
      const ref = firebase
          .firestore()
          .collection("nanoCompetencies");
        const snapshot = await ref.get();
        const fetchedData = []
        const sortedData = []
        snapshot.forEach(doc => {
          fetchedData.push(doc.data());
          // console.log(doc.data());
          // console.log(data)
        });
        setTotalLength(fetchedData.length)

      fetchedData.sort((a, b) => (a.index > b.index) ? 1 : -1)
        if(selectedDataSet == 1) {
          setData(fetchedData)
          setReformattedData(fetchedData)

        }
        fetchedData.map((d,i) => {
          if(d.author == auth.auth.uid) {
            sortedData.push(d)
          }
        })
        if(selectedDataSet == 2){
          setData(sortedData)
          setReformattedData(sortedData)
        }
      }
      getdata()

  },[localStore, dispatch, selectedDataSet])

  const [reformattedData, setReformattedData] = useState([]);



// console.log(reformattedData)
// console.log(data)
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState([]);
  const [storageData, setStorageData] = useState([]);
  const [comp, setComp] = useState(0);
  const [secondary, setSecondary] = useState(false);

  const [destination, setDestination] = useState("");

  const [searchQuery, setSearchQuery] = useState("");

const changeDataSet = (e) => {
  if(e === 1) {
    setSearchQuery("")
    setSelectedDataSet(1)
  }
  if(e === 2) {
    setSearchQuery("")
    setSelectedDataSet(2)
  }
}

  // if (searchQuery == "") {
  //   setReformattedData(data)
  // } else {
  // }
// };



  // const dataFiltered = filterData(searchQuery, data);





  const pages = [
    {name: destination, address: "/nanocontent"},
    // {name: "nanocontent", address:`destination`},
];


  const onDelete = (d) => {
    dispatch(deleteItem(d))
    enqueueSnackbar(`${d.name} Successfully deleted!`, { variant: "success" })

  }

  const SearchBar = styled(TextField)({


  '& label.Mui-focused': {
    color: "#1976d2",
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: "#1976d2",
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: "#c4c4c4",
      borderRadius: "200px"
    },
    '&:hover fieldset': {
      borderColor: "#c4c4c4",
    },
    '&.Mui-focused fieldset': {
      borderColor: "#1976d2",
    },
  },
});

useEffect(() => {
  if(data && searchQuery !== "") {
    setReformattedData(data.filter((d) => (d.authorName + " " + d.name + " " + d.description).toLowerCase().includes(searchQuery)));
  }
}, [searchQuery])

  const noQuery = () => {
    setSearchQuery("")
  }

return (
  <div>
    {isLoading == true ? (

      <CircularProgress style={{ display: "flex", position: "absolute", top: "50%", left: "50%", marginRight: "-50%", transform: "translate(-50%, -50%)" }} />

    ) : (
    
    <>
    <h1 className="pageHeader1">NanoCompetencies</h1>
      
      {data.length < 1 ? (
        
        <div>
          <Box textAlign="center">
            <Button onClick={() => setOpen(!open)} color="success" variant="outlined" style={{ margin: "30px" }}>
              <tableIcons.AddOutline color="success" />
            </Button>

            <h3>You currently have no NanoCompetencies</h3>
            <h3>Please proceed by creating content</h3>

          </Box>

          {open == true && (
            <CreateNanoCompModal listLength={totalLength} isOpen={open} setIsOpen={setOpen} />
          )}

        </div>
        
        ) : (
        
        <div>
          <Box textAlign="center">
            <Button onClick={() => setOpen(!open)} color="success" variant="outlined" style={{ margin: "30px" }}>
              <tableIcons.AddOutline color="success" />
            </Button>
            
            <h3>{reformattedData.length} NanoCompetencies found</h3>
          
          </Box>
          
          {open == true && (
            <CreateNanoCompModal listLength={totalLength} isOpen={open} />
          )}
          
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justify="center"
            >
                  
  
              <ButtonGroup  color="primary" style={{ margin: "20px 0 20px 0" }}>
                <Button variant={selectedDataSet === 1 ? "contained" : "outlined"} onClick={() => changeDataSet(1)}>All competencies</Button>
                <Button variant={selectedDataSet === 2 ? "contained" : "outlined"}  onClick={() => changeDataSet(2)}>My competencies</Button>
              </ButtonGroup>

              <div style={{ margin: "20px 5vw -40px 5vw" }}>


                <TextField 
                  size="small"
                  placeholder="Search..."
                  sx={{
                    '& label.Mui-focused': {
                      color: "#1976d2",
                    },
                    '& .MuiInput-underline:after': {
                      borderBottomColor: "#1976d2",
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: "#c4c4c4",
                        borderRadius: "200px"
                      },
                      '&:hover fieldset': {
                        borderColor: "#c4c4c4",
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: "#1976d2",
                      },
                    },
                    width: "auto",
                    maxWidth: "80vw"
                  }}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  value={searchQuery}
                  InputProps={{
                    endAdornment:( 
                          <tableIcons.Search 
                            style={{ fill: "#c4c4c4" }}
                           
                          /> 
                    )
                  }}
                >
                  </TextField>

              </div>
              

            </Grid>
            <List style={{ margin: "5vh 5vw 5vh 5vw" }}>

              {reformattedData.map((d, i) => (
                
                  <ListItem
                    key={d.index}
                    onClick={() => setDestination(d.name.replace(/ /g,"_"))}
                    secondaryAction={
                    <>
                      {d.author == "isExample" && (
                        <>
                          <Tooltip title="Top 5 Content Creator">
                            <IconButton style={{ marginRight: "25px" }} edge="end" aria-label="delete" onClick={() => console.log("signed up to " + d.name)}>
                              <tableIcons.StarRateIcon />
                            </IconButton>
                          </Tooltip>
                        </>
                    )}

                    {d.author != auth.auth.uid ? (
                      <>
                        <Tooltip title="Sign up">
                          <IconButton edge="end" aria-label="delete" onClick={() => console.log("signed up to " + d.name)}>
                            <tableIcons.Check />
                          </IconButton>
                        </Tooltip>
                      </>
                    
                    ) : (
                    <>
                    </>
                    )}

                    {d.author == auth.auth.uid && (
                      <>
                        <Tooltip title="Delete">
                          <IconButton edge="end" aria-label="delete" onClick={() => onDelete(d)}>
                            <tableIcons.Delete />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                    </>
                    }
                  >

                  <>
                    <Link 
                      to={pages[0].address} 
                      state={d}
                      style={{ textDecoration: "none", color: "#000", width: "100%" }}
                      key={d.index}
                    >
                      <ListItemText
                        primary={d.name}
                        // secondary={d.description.length > 200 ? (
                        // d.description.slice(0, 200) + "..." ) : (d.description)}
                      />

                      <Typography
                        sx={{ display: 'inline', fontSize: "10px" }}
                        component="span"
                        variant="body12"
                        color="text.primary"
                      >
                        {d.authorName + " "}
                      
                      {d.creationDate}
                      </Typography>
                      <ListItemText
                        // primary={d.name}
                        style={{ width: "80%" }}
                        secondary={d.description.length > 200 ? (
                        d.description.slice(0, 200) + "..." ) : (d.description)}
                      />

                    </Link>
                  </>
                  </ListItem>
               
              ))}
            </List>
        </div>
      )}
    </>
  )}
  </div>
  );
};

export default NanoComp;